var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.575C8.36667 11.575 8.24167 11.5583 8.125 11.525C8.00833 11.475 7.9 11.4 7.8 11.3L4.2 7.7C4 7.5 3.9 7.26667 3.9 7C3.91667 6.73333 4.01667 6.5 4.2 6.3C4.4 6.1 4.63333 6 4.9 6C5.18333 5.98333 5.425 6.075 5.625 6.275L7.5 8.15V1C7.5 0.716666 7.59167 0.483332 7.775 0.299999C7.975 0.099999 8.21667 -9.53674e-07 8.5 -9.53674e-07C8.78333 -9.53674e-07 9.01667 0.099999 9.2 0.299999C9.4 0.483332 9.5 0.716666 9.5 1V8.15L11.375 6.275C11.575 6.075 11.8083 5.98333 12.075 6C12.3583 6 12.6 6.1 12.8 6.3C12.9833 6.5 13.075 6.73333 13.075 7C13.0917 7.26667 13 7.5 12.8 7.7L9.2 11.3C9.1 11.4 8.99167 11.475 8.875 11.525C8.75833 11.5583 8.63333 11.575 8.5 11.575ZM2.5 16C1.95 16 1.475 15.8083 1.075 15.425C0.691667 15.025 0.5 14.55 0.5 14V12C0.5 11.7167 0.591667 11.4833 0.775 11.3C0.975 11.1 1.21667 11 1.5 11C1.78333 11 2.01667 11.1 2.2 11.3C2.4 11.4833 2.5 11.7167 2.5 12V14H14.5V12C14.5 11.7167 14.5917 11.4833 14.775 11.3C14.975 11.1 15.2167 11 15.5 11C15.7833 11 16.0167 11.1 16.2 11.3C16.4 11.4833 16.5 11.7167 16.5 12V14C16.5 14.55 16.3 15.025 15.9 15.425C15.5167 15.8083 15.05 16 14.5 16H2.5Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download.fcabe9e4a3caab4850e585342b951449.svg";